<template>
  <div role="dialog" aria-modal="true" aria-labelledby="snapshot-share-title" tabindex="-1" class="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50">
    <div class="bg-white p-8 rounded-lg shadow-lg md:w-2/4 w-96 ">
      <div class="flex items-center">
        <span class="text-3xl pr-4">⚠️</span>
        <h2 id="snapshot-share-title" class="md:text-2xl text-xl font-bold text-red-600">Hang on! We need a name and email address</h2>
      </div>
      <p class="mt-4 text-lg">To proceed with this order, please enter your name and personal email address. Upon completion, you'll receive an email of your order confirmation. Click continue when you're ready.</p>
      <div class="flex flex-col">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form
           @submit.prevent="handleSubmit(submitFormModal)"
          >
            <div class="my-2">
              <ValidationProvider
                rules="required|min:3"
                v-slot="{ errors, valid }"
              >
                <label for="name" class="block ">Full Name</label>
                <input 
                  type="text" 
                  id="name" 
                  name="name" 
                  v-model="form.name"
                  class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500" 
                  placeholder="Enter your full name"
                  v-bind:class="{
                    'border-red-700 text-red-900': errors.length > 0,
                    'border-green-700': valid,
                  }"
                ><span>{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="my-2">
              <ValidationProvider
                name="Email Address"
                rules="required|email|personal_email"
                v-slot="{ valid, errors }"
                vid="email"
              >
                <label for="email" class="block ">Email Address</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500" 
                  placeholder="Enter your personal email address" 
                  v-model="form.email"
                  v-bind:class="{
                    'border-red-700 text-red-900': errors.length > 0,
                    'border-green-700': valid,
                  }"
                ><span>{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="mt-6 flex justify-between">
              <button @click="$emit('close')" class="bg-gray-500 text-white py-2 px-4 rounded hover:bg-gray-600">
                Cancel
              </button>
              <button 
                type="submit"
                id="overwriteModalSubmitBtn"
                class="bg-green-500 text-white py-2 px-4 rounded hover:bg-green-700 disabled:opacity-75"
              >
                Continue
              </button>
            </div> 
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { extend } from "vee-validate";
import {
  required,
  min,
  max,
  email,
  regex,
  confirmed
} from "vee-validate/dist/rules"

extend("personal_email", {
  message: (field) =>
      "The " +
      field +
      " value is not a personal email, please enter an email not ending in ac.uk.",
    validate: (value) => !/^.*((\.ac\.uk)|(bpp\.com))$/.test(value),
  });

extend("required", {
  ...required,
  message: "This field is required",
});
extend("min", min);
extend("confirmed", {
  ...confirmed,
  message: "Your email addresses do not match",
});
extend("regex", regex);
extend("max", max);
extend("email", email);

export default {
  name: "ShareBasketFormModal",
  data() {
    return {
      form: {
        name: "",
        email: null
      }
    }
  },
  methods: {
    submitFormModal() {
      // Good to submit for checkout
      this.$emit("submitModal", this.form);
    }
  }
}
</script>
